const config = {
  // apiUrl: "http://159.65.190.181:3000",
  apiUrl: process.env.REACT_APP_API_URL,
  // apiUrl: "http://localhost:3030",
};

export default config;

